import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ProductSkeleton } from "../../components/common/ProductSkeleton";
import Product from "./Product";

const Products = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["all-products"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/products`);
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.message || "Something went wrong");
      return json;
    },
  });

  const products = data?.products ?? [];

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 py-8 sm:py-10">
        {/* Error */}
        {isError && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
            <p className="text-red text-sm">{error?.message}</p>
          </div>
        )}

        {/* Loading */}
        {isPending && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {Array.from({ length: 12 }).map((_, i) => (
              <ProductSkeleton key={i} />
            ))}
          </div>
        )}

        {/* Empty */}
        {!isPending && !isError && products.length === 0 && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 text-center">
            <p className="text-gray-900 font-semibold">No products available</p>
            <p className="text-sm text-gray-500 mt-1">Check back soon.</p>
          </div>
        )}

        {/* Products */}
        {!isPending && !isError && products.length > 0 && (
          <Product products={products} title="Our Products" showFilterButton />
        )}
      </div>
    </div>
  );
};

export default Products;
